<template>
    <DxDataGrid :data-source="dsMeserii" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="ID">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="300" :height="360" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" /> 
            </DxPopup>
            <DxFormGrid>
                <DxItem :col-span="1" :col-count="1" item-type="group">
                    <DxItem data-field="name" :editor-options="{ width: 250, height: 50 }"/>
                    <DxItem data-field="code" :editor-options="{ width: 250, height: 50 }" />
                    <DxItem data-field="Active" editor-type="dxCheckBox" :css-class="'checkbox-center'" :editor-options="{ elementAttr: { style: 'display:flex; justify-content:center;' } }"/>
                </DxItem>
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Meserie
            </div>
        </template>
        <DxColumn data-field="code" caption="Cod"/>
        <DxColumn data-field="name" caption="Nume"/>
        <DxColumn data-field="Active" caption="Activ?"/>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" height="360px" width="300px">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Meserie
            </div>
        </template>
        <DxForm :col-count="1" :data-source="newMeserie" label-alignment="center">
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newMeserie.name" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Cod" :is-required="true">
                <template #default>
                    <DxTextArea :value="newMeserie.code" @value-changed="onCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Activ?" :is-required="true">
                <template #default>
                    <div style="display: flex; justify-content: center;">
                        <DxCheckBox :value="newMeserie.Active" @value-changed="onActiveValueChanged" />
                    </div>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem,
  DxItem as DxFormItem,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxSearchPanel,
  DxSearch
} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';
import PER_Meserii from '@/services/PER/PER_Meserii';

export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem
    },
    data() {
        return {
            dsMeserii: {} as DataSource,
            dataGridRef: ref<DxDataGrid | null>(null),
            addPopupVisible: false,
            editPopupVisible: false,
            newMeserie: {
                name: '',
                code: '',
                Active: false
            },
            addButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
        }
    },
    mounted() {
        this.dsMeserii = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `PER_Meserii`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage()
    },
    methods: {
        onRefreshClick() {
            const gridInstance = this.dataGridRef?.instance;
            if (gridInstance) {
                gridInstance.refresh();
                notify("Datele au fost actualizate cu succes!", "success", 3000);
            }
        },
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onAddClick() {
            this.addPopupVisible = true
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return; 
            }
            try {
                gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
            }
        },
        onSaveAdd() {
            if (!this.newMeserie.name || this.newMeserie.name.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 2000)
                return
            }
            if (!this.newMeserie.code || this.newMeserie.code.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 2000)
                return
            }
            PER_Meserii.save(this.newMeserie).then((meserie) => {
                this.addPopupVisible = false
                notify('Datele au fost salvate cu succes!', 'success', 2000)
                this.newMeserie = {
                    name: '',
                    code: '',
                    Active: false,
                }
                this.onRefreshClick()
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 2000);
            })
        },
        onCloseAdd() {
            this.addPopupVisible = false
            this.newMeserie.name = ''
            this.newMeserie.code = ''
            this.newMeserie.Active = false
        },
        onNumeValueChanged(e: any) {
            this.newMeserie.name = e.value
        },
        onCodValueChanged(e: any) {
            this.newMeserie.code = e.value
        },
        onActiveValueChanged(e: any) {
            this.newMeserie.Active = e.value
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
    },
})
</script>
<style>
.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.circle-true {
  background-color: #4caf50;
  color: white;
}

.circle-false {
  border: 2px solid #aaa;
}

.checkbox-center .dx-field-item-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 110px;
  margin-top: 30px;
}
</style>